import { Component, OnInit } from '@angular/core';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'switcher-scpi',
    templateUrl: './switcher-scpi.component.html',
    styleUrls: ['./switcher-scpi.component.scss'],
    standalone: false
})
export class SwitcherScpiComponent implements OnInit {
  scpiType: string = '';
  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit(): void {
    this.scpiType =
      this.subscriptionFacade.getPledge()?.parameters?.scpiSelectionType ||
      'FREE';
  }
}
